import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IWechatUser2, defaultValue } from 'app/shared/model/wechat-user-2.model';

export const ACTION_TYPES = {
  FETCH_WECHATUSER2_LIST: 'wechatUser2/FETCH_WECHATUSER2_LIST',
  FETCH_WECHATUSER2: 'wechatUser2/FETCH_WECHATUSER2',
  CREATE_WECHATUSER2: 'wechatUser2/CREATE_WECHATUSER2',
  UPDATE_WECHATUSER2: 'wechatUser2/UPDATE_WECHATUSER2',
  DELETE_WECHATUSER2: 'wechatUser2/DELETE_WECHATUSER2',
  RESET: 'wechatUser2/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IWechatUser2>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type WechatUser2State = Readonly<typeof initialState>;

// Reducer

export default (state: WechatUser2State = initialState, action): WechatUser2State => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_WECHATUSER2_LIST):
    case REQUEST(ACTION_TYPES.FETCH_WECHATUSER2):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_WECHATUSER2):
    case REQUEST(ACTION_TYPES.UPDATE_WECHATUSER2):
    case REQUEST(ACTION_TYPES.DELETE_WECHATUSER2):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_WECHATUSER2_LIST):
    case FAILURE(ACTION_TYPES.FETCH_WECHATUSER2):
    case FAILURE(ACTION_TYPES.CREATE_WECHATUSER2):
    case FAILURE(ACTION_TYPES.UPDATE_WECHATUSER2):
    case FAILURE(ACTION_TYPES.DELETE_WECHATUSER2):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WECHATUSER2_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WECHATUSER2):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_WECHATUSER2):
    case SUCCESS(ACTION_TYPES.UPDATE_WECHATUSER2):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_WECHATUSER2):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/wechat-user-2-s';

// Actions

export const getEntities: ICrudGetAllAction<IWechatUser2> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_WECHATUSER2_LIST,
  payload: axios.get<IWechatUser2>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IWechatUser2> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_WECHATUSER2,
    payload: axios.get<IWechatUser2>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IWechatUser2> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_WECHATUSER2,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IWechatUser2> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_WECHATUSER2,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IWechatUser2> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_WECHATUSER2,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
